// extracted by mini-css-extract-plugin
export default {"root":"UR8BDz","gift":"jhKtFZ","swap":"iXBCWC","oldPrice":"n_PYsC","label":"bI0GeQ","labelTypeDiscount":"RCQTQP","saleLabel":"mLYtwg","price":"azxZhr"};